import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Icon,
  Image,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
  forwardRef,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { FiHome, FiSettings, FiTrendingUp, FiLogOut } from 'react-icons/fi';
import { RiScanLine } from 'react-icons/ri';
import { MdEventRepeat, MdNotificationsNone } from 'react-icons/md';

import { Link } from 'react-router-dom';
import { useUIStore } from '#store';

export default function UserTab() {
  const user = useUIStore((state) => state.user);
  const logoutUser = useUIStore((state) => state.logoutUser);
  if (!user) {
    return null;
  }

  const menuItemStyles = {
    py: 2,
    display: 'flex',
    alignItems: 'center',
    iconSpacing: 3,
    _hover: {
      bg: 'brand.50',
      color: 'brand.600',
    },
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        leftIcon={
          <Avatar
            size="sm"
            src={user.picture}
            variant={'ghost'}
            colorScheme="teal"
          />
        }
        bg="none"
        _hover={{
          bg: 'none',
          opacity: 0.9,
        }}
        _active={{
          bg: 'none',
        }}
      />
      <MenuList
        borderTop="3px solid"
        borderTopColor="brand.500"
        boxShadow="lg"
        minW="220px"
      >
        <MenuGroup title="My Account" color="brand.600" fontSize="sm">
          <MenuItem
            as={Link}
            to="/profile/dashboard"
            icon={<Icon as={FiHome} verticalAlign="middle" />}
            {...menuItemStyles}
          >
            Dashboard
          </MenuItem>
          <MenuItem
            as={Link}
            to="/profile/trackers"
            icon={<Icon as={FiTrendingUp} verticalAlign="middle" />}
            {...menuItemStyles}
          >
            Trackers
          </MenuItem>
          <MenuItem
            as={Link}
            to="/profile/scans"
            icon={<Icon as={RiScanLine} verticalAlign="middle" />}
            {...menuItemStyles}
          >
            Scans
          </MenuItem>
          <MenuItem
            as={Link}
            to="/profile/alerts"
            icon={<Icon as={MdNotificationsNone} verticalAlign="middle" />}
            {...menuItemStyles}
          >
            Alerts
          </MenuItem>
          <MenuItem
            as={Link}
            to="/profile/subscriptions"
            icon={<Icon as={MdEventRepeat} verticalAlign="middle" />}
            {...menuItemStyles}
          >
            Subscriptions
          </MenuItem>
          <MenuItem
            as={Link}
            to="/profile/profile"
            icon={<Icon as={FiSettings} verticalAlign="middle" />}
            {...menuItemStyles}
          >
            Profile
          </MenuItem>
        </MenuGroup>
        <MenuDivider borderColor="brand.100" />
        <MenuItem
          as={Link}
          to="/"
          onClick={logoutUser}
          icon={<Icon as={FiLogOut} verticalAlign="middle" />}
          {...menuItemStyles}
          color="gray.600"
          _hover={{
            bg: 'red.50',
            color: 'red.500',
          }}
        >
          Logout
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
